import React from "react";
import CvSection from "./cvSection/index";
import NDAInformation from "../common/NDASection/index";
import CertificatesSection from "../common/CertificatesSection/index";
import OtherFilesSection from "../common/OtherFilesSection";
import { useTranslation } from "react-i18next";

export default function FreelancerDocuments() {
  const [t] = useTranslation();
  return (
    <div className="flex flex-col items-start p-[24px] gap-[30px]  flex-[1_0_0]">
      <div className="text-[#1D1B22]  text-center font-semibold text-[30px] leading-[40px] font-['General_Sans']">
        {t("documents")}
      </div>
      <CvSection isShowEditIcon={true} />

      <div className="flex flex-col items-start gap-3 self-stretch w-[1156px] h-px bg-[#E4E4E7] w-full"></div>

      <NDAInformation isShowEditIcon={false} />
      <div className="flex flex-col items-start gap-3 self-stretch w-[1156px] h-px bg-[#E4E4E7] w-full"></div>

      <CertificatesSection isShowEditIcon={false} />
      <OtherFilesSection />
    </div>
  );
}
